import cn from "@/v2-ui/utils/utils.cn"
import CountryFlag from "@/v2-backoffice-client/country/CountryFlag"
import { useCountryQuery } from "@/v2-backoffice-client/country/country.query"

export type CountryLabelProps = {
  className?: string
  code: number | null | undefined
  // Rendered when no country is set. Callers say what that means in
  // their own context ("Not set", "Follows the project", ...).
  emptyLabel?: string
}

// Renders a stored country code as a flag and a name. A code the catalog
// doesn't know is shown as the bare number rather than hidden — that is a
// data problem the operator should be able to see.
function CountryLabel(props: CountryLabelProps) {
  const { className, code, emptyLabel = "Not set" } = props
  const { data } = useCountryQuery()

  if (code === null || code === undefined) {
    return <span className="text-muted-foreground">{emptyLabel}</span>
  }

  const country = data?.getCountries.find((c) => c.Code === code)
  if (!country) {
    return <span className="text-muted-foreground">#{code}</span>
  }

  return (
    <span className={cn("flex items-center gap-2", className)}>
      <CountryFlag alpha2={country.Alpha2} name={country.Name} />
      {country.Name ?? country.Alpha2}
    </span>
  )
}

export default CountryLabel
